<div class="title-components">
  <h1>Papelera de reciclaje HOE</h1>
</div>



<div class="container-global-components ConVH">

  <div class="Table-Lib Table-container-Global">

    <p-table #dt [value]="List_RecycleBin" [(selection)]="SelectedList_RecycleBin" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name']">


      <ng-template pTemplate="caption">

        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <!--?===== INPUT FOR HOE SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_RecycleBin" type="text"
                (input)="dt.filterGlobal(Filter_RecycleBin, 'contains')" placeholder="Papelera de reciclaje" />
            </div>
          </div>
          <div class="right-CT">

          </div>
        </div>

      </ng-template>


      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Table_Header of HeadersRB">

            <ng-container *ngIf="Table_Header.Key_Header === 'ICONF'">
              <th pSortableColumn="Extension" class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Extension"></p-sortIcon>
                    <p-columnFilter field="F_Extension" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Tipo documento</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="this.Filter_Global_Check.Extension"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <ng-container *ngIf="option.Value==='dir'">
                              <div class="Icon-Table-File">
                                <div class="Content-Icon">
                                  <img src="./assets/Global/icons/Folder.png" alt="" srcset="">
                                  <span>Carpeta</span>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngFor="let icon of Icons_Image">
                              <div *ngIf="option.Value.toUpperCase()==icon.Extension.toUpperCase()" class="Icon-Table-File">
                                <div class="Content-Icon">
                                  <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                                  <span>{{icon.Name}}</span>
                                </div>
                              </div>
                            </ng-container>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMFI'">
              <th pSortableColumn="Name" class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'ROUTE'">
              <th pSortableColumn="Path" class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Path"></p-sortIcon>
                    <p-columnFilter type="text" field="Path" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'USEDE'">
              <th pSortableColumn="Name_User" class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name_User"></p-sortIcon>
                    <p-columnFilter field="Name_User" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre usuario</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Name_User_Deleted"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DATED'">
              <th pSortableColumn="Date_Deleted" class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Deleted"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Deleted" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header==='DELET'">
              <th class="{{Table_Header.Key_Header}}"></th>
            </ng-container>

          </ng-container>

        </tr>

      </ng-template>


      <ng-template pTemplate="body" let-List_RecycleBin let-i="rowIndex">

        <tr>

          <td *ngFor="let Table_Header of HeadersRB" class="{{Table_Header.Key_Header}}">

            <ng-container *ngIf="Table_Header.Key_Header === 'ICONF'">

              <div *ngIf="List_RecycleBin.Directory" class="Folder-Table">
                <div class="Folder_back">
                  <div class="Paper"></div>
                  <div class="Paper"></div>
                  <div class="Paper"></div>
                  <div class="Folder_front"></div>
                  <div class="Folder_front right"></div>
                </div>
              </div>

              <ng-container *ngFor="let icon of Icons_Image">

                <div *ngIf="List_RecycleBin.Extension.toUpperCase()==icon.Extension.toUpperCase()" class="Icon-Table-File">
                  <div class="Content-Icon">
                    <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMFI'">
              {{List_RecycleBin.Name}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'ROUTE'">
              {{Clean_Route(List_RecycleBin.Path)}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'USEDE'">
              {{List_RecycleBin.Name_User}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DATED'">
              {{Get_Date_Deleted(List_RecycleBin.Date_Deleted)}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header==='DELET'">
              <div (click)="Restore_File_Or_Directory(List_RecycleBin)" class="Btn-Option button-square Restore">
                <i class="fa-solid fa-trash-can-arrow-up"></i>
              </div>
              <div (click)="Delete_File_or_Directory(List_RecycleBin)" class="Btn-Option button-square Delete">
                <i class="fa-regular fa-trash-can"></i>
              </div>
            </ng-container>

          </td>

        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="List_RecycleBin.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr class="Not-Files-tr">
          <div class="Not-Files" *ngIf="List_RecycleBin.length===0 && LoadPage">
            <div class="Img-Not">
              <img src="./assets/Global/Ilustrations/Not-Recycle.png" alt="">
            </div>
            <div class="Text-Not-Files">
              La papelera de reciclaje esta vacía, no tiene procesos o carpetas.
            </div>
          </div>
        </tr>
      </ng-template>

    </p-table>

  </div>

</div>


<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
